export const styles = {
  heading: {
    color: "black",
    font: "normal normal 700 24px/28px Roboto",
  },
  mainBox:{
    display:"flex",
    justifyContent:"space-between",
    width:"100%",
  },
  removeArrow:{
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                        { display: "none" },
                      "& input[type=number]": { MozAppearance: "textfield" },
  },
  headingForEditUser: {
    color: "black",
    font: "normal normal 700 24px/28px Roboto",
    width:"100%"
  },
  searchAndFilter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    flexWrap: "wrap",
    marginBottom: "16px",
  },
  addButton: {
    height: 40,
    padding: "6px 16px",
    borderRadius: "12px",
    boxShadow: "none",
    textTransform: "none" as const,
    fontWeight: 600,
    fontSize: 14,
    backgroundColor: "#6C3CE9",
    whiteSpace: "nowrap" as const,
    "&:hover": {
      boxShadow: "none",
      backgroundColor: "#5B2FD1",
    },
  },
  searchAndAdd: {
    gap: "1rem",
    width: "100",
    display: "flex",
    alignItems: "end",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  HeadBtns: {
    height: "35px",
    width: "150px",
    textAlign: "center",
    padding: "auto 50px",
    fontFamily: "Roboto",
  },
  inputField: {
    height: "50px",
    padding: "5px 20px 5px 5px",
  },
  headContainer: {
    display: "flex",
    alignItems: "center",
    padding: "0 0 10px 0",
    justifyContent: "space-between",
  },
  flexContainer: {
    gap: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  switch_Cont: {
    gap: "5px",
    display: "flex",
    marginRight: "20px",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    top: "50%",
    width: 500,
    left: "50%",
    boxShadow: 24,
    position: "absolute",
    borderRadius: "12px",
    height: "fit-content",
    bgcolor: "background.paper",
    border: "1px solid lightGray",
    transform: "translate(-50%, -50%)",
  },
  headingBar: {
    width: "100%",
    height: "50px",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    padding: "20px 10px 0px 20px",
    borderBottom: "1px solid lightGray",
  },

  heading_ac: {
    color: "#673ab7",
    textAlign: "center",
    margin: "10% 0 15% 0",
  },
  button: {
    padding: "10px 20px 20px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "15px ",
    gap: "20px",
  },
  button_box: {
    padding: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "15px ",
    gap: "20px",
  },

  inputBox: {
    padding: "20px",
    display: "block",
    justifyContent: "center",
    alignItems: "center",
  },
  input: {
    height: "150px",
    width: "150px",
    border: "1px dotted lightGray",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "6px 0px 6px 0px",
  },
  paper: {
    backgroundColor: "rgb(255, 255, 255)",
    color: "rgb(38, 38, 38)",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    overflow: "hidden",
    border: "1px solid rgb(230, 235, 241)",
    borderRadius: "8px",
  },
  modal: {
    padding: "30px 20px 0px 20px",
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    flexDirection: "column",
    gap: "10px",
  },

  selectDropdown: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.8125rem",
    color: "#364152",
    fontWeight: "400",
    borderRadius: "12px",
    "& > div": {
      background: "none",
      color: "black",
      borderRadius: "12px",
      fontSize: "0.8125rem",
      fontWeight: "400",
    },
    "& fieldset": {
      color: "black",
      borderRadius: "8px",
    },
  },
  // selectDropdown: {
  //   padding:"auto 10px",
  //   height: "35px",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   // height: "60px",
  //   fontSize: "0.8125rem",
  //   color: "#364152",
  //   fontWeight: "400",
  //   borderRadius: "12px",
  //   "& > div": {
  //     background: "none",
  //     color: "black",
  //     borderRadius: "12px",
  //     fontSize: "0.8125rem",
  //     fontWeight: "400",
  //   },
  //   "& fieldset": {
  //     color: "black",
  //     borderRadius: "8px",
  //   },
  // },
  image: {
    height: "150px",
    width: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "70px",
  },
  profileBox: {
    height: "160px",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "10px",
  },
  photoInput: {
    height: "150px",
    width: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid lightgray",
    background: "#F8FAFC",
    borderRadius: "75px",
    cursor: "pointer",

    // border:"1px solid black"
  },
  fileField: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    fontSize: "0.8125rem",
    color: "#364152",
    fontWeight: "400",
    borderRadius: "12px",
    "& > div": {
      background: "none",
      color: "black",
      borderRadius: "12px",
      fontSize: "0.8125rem",
      fontWeight: "400",
    },
    "& fieldset": {
      color: "black",
      borderRadius: "8px",
    },
  },
  csv_btn: {
    height: "45px",
    marginRight: "10px",
    borderRadius: "8px",
  },
  client_filter: {
    width: "150px",
    boxShadow: "none",
    fontSize: "30px",
    borderRadius: "8px",
    height: "35px",
    padding: "auto 10px",
    // border:"1px solid green"
  },
  calenderBtn:{
    display:"flex",
    justifyContent:"space between",
    alignItems:"center",
    gap:"20px",
    border:"1px solid green",
  },
  datePicker:{
    border:"1px solid red",
    cursor:"pointer !important"
  }
};
